import {Component} from '@angular/core';
import {ACTIVE_JOBS, BUSINESS, EXECUTIONS, HOME_PAGE} from '../services/shared-data.service';
import {Router} from '@angular/router';

@Component({
    selector: 'app-side-bar',
    templateUrl: './side-bar.component.html',
    styleUrls: ['./side-bar.component.css'],
    standalone: false
})

export class SideBarComponent {

  display: boolean = false;

  constructor(private router: Router) {
  }

  navItem: any[] = [
    {name: 'RobotDashboard'},
    {name: 'Executions'},
    {name: 'ActiveJobs'},
    // {name: 'Business'},
    // {name: 'Job Details'},

  ]

  visible(name: any) {
    switch (name) {
      case 'RobotDashboard':
        this.router.navigate([HOME_PAGE]);
        this.display = false;
        break;
      case 'Executions':
        this.router.navigate([EXECUTIONS]);
        this.display = false;
        break;
      case 'Business':
        this.router.navigate([BUSINESS]);
        this.display = false;
        break;
      case 'ActiveJobs':
        this.router.navigate([ACTIVE_JOBS]);
        this.display = false;
        break;
      case 'Job Details':
        this.router.navigate(['newDetails']);
        this.display = false;
        break;

    }
  }


}
